import { useEffect, useState } from "react";
import { Button, Modal } from "cai-fusion";

import { useTransientVisibility } from "../../../../fusion/Contexts/VisualContext";
import { useSiftV2 } from "../../../contexts/siftV2Context";

const RenameOpportunityModal = () => {

    const { hide, visibilityStates } = useTransientVisibility();

	const [name, setName] = useState("");
	const { currOpp, renameOpportunity } = useSiftV2();
	
	useEffect(() => {
		if(!visibilityStates.RenameOpportunityModal){
			setName(currOpp?.name);
		}
	}, [visibilityStates.RenameOpportunityModal])

	const handleKeyPress = (event) => {
		if (event.key === "Enter") {
			if (!event.shiftKey) {
				event.preventDefault();
				// renameChat(name);
				hide('RenameOpportunityModal');
				setName("");
			}
		}
	};

	return (
		<Modal
			isHidden={ !visibilityStates.RenameOpportunityModal }
			id="rename-modal"
			clickOutsideToClose={ true }
			title="Rename Opportunity"
			onClose={(e) => {
				hide('RenameOpportunityModal');
				e.preventDefault();
			}}
			actions={
				<>
					<Button outline onClick={(e) => { e.preventDefault(); setName(""); hide('RenameOpportunityModal'); }} children="Cancel"/>
					<Button onClick={(e) => { 
							e.preventDefault(); 
							renameOpportunity(name);
							setName(""); 
							hide('RenameOpportunityModal'); 
						}} 
						children="Save"
					/>
				</>
			}
		>
			<div className="l-row">
				<div className="l-one-col">
					<p>You can rename this opportunity to make it easier to find in your history.</p>
					<form action="" className="o-form">
						<div className="m-form-group l-mt-sm">
							<label htmlFor="" className="a-label">Opportunity Name</label>
							<input type="text" value={name} onKeyDown={(e) => handleKeyPress(e)} onChange={(e) => { setName(e.target.value); e.preventDefault(); }} className="a-text-input"/>
						</div>
					</form>
				</div>
			</div>
		</Modal>
	);
};

export default RenameOpportunityModal;